// 全局路由中间件：保护需要登录的页面
export default defineNuxtRouteMiddleware((to) => {
  const userStore = useUserStore()

  // 仅在客户端执行（本地存储、弹窗等）
  if (import.meta.server) return

  // 初始化一次，以防首屏未加载Header时丢失持久化状态
  if (!userStore.isLoggedIn && !userStore.loginData) {
    try { userStore.initFromStorage() } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('[auth.middleware] initFromStorage failed', e)
    }
  }

  const needAuth = (to.meta as any)?.auth === true
  if (needAuth && !userStore.isLoggedIn) {
    userStore.setAuthModalVisible(true)
    return navigateTo('/')
  }
})

// 导入声明（保持nuxt自动导入）
import { useUserStore } from '~/stores/user'
